module.exports = __webpack_public_path__ + "static/media/feature_dropdown.e76cebc0.jpg";